import { AppDispatch } from '../store'
import { showMessage } from '../reducers/AppCondition/AppConditionSlice'

export const errorHandler = (err: any) => (dispatch: AppDispatch) => {
    if (err?.response?.data?.message) {
        dispatch(showMessage(err.response.data.message))
    }
}